<style lang="scss" scoped>
.create-tile {
	cursor: pointer;
	border: 2px dashed #d4d4d4;
	border-radius: 5px;
	height: 122px;
	@include flex-center;
	i {
		margin-left: 40px;
		position: relative;
		top: 1px;
		font-size: 20px;
	}
	h3 {
		margin: 54px 13px;
	}
}
</style>

<template lang="pug">
    .create-tile(@click="toggleModal")
        i.fa.fa-plus
        h3 Create new classroom
</template>

<script>
import CreateClassroomModal from "@/components/classroom/Create";
import Introduction from "@/components/classroom/create/Introduction";

export default {
	props: {
		showIntroduction: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		toggleModal() {
			if (this.showIntroduction) {
				this.$vuedals.open({
					component: Introduction,
					size: "lg",
					title: "Create classroom"
				});
			} else {
				this.$vuedals.open({
					component: CreateClassroomModal,
					size: "lg",
					title: "Create classroom"
				});
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/employee/CreateClassroomTile.vue